import React from "react";
import '../checkout/style/checkout.css';
import Breadcrumb from "../../Component/breadcrumb/Breadcrumb";
import { Link } from "react-router-dom";
import { Button } from 'react-bootstrap';
import DeliveryInformation from "../../Component/Common/DeliveryInformation";

function Summarys() {
  return (
    <>
      <Breadcrumb />
      <div className="TableBoxCheckout">
        <div className="container">
          <div className="row">
            <div className="col-md-9 col-sm-12">
              <div className="row">
                <div className="col-md-4">
                  <div className="p-2" style={ {border:" 1px solid rgb(222, 222, 222)", minHeight:"153px", marginBottom: "10px ", maxHeight:"300px"}}> 
                  <p className="text-sm mb-1"><strong>Customer Information</strong></p>
                  <p className="text-sm P-text">
                    Obsessions Testing Customer - Mantu<br />
                    Address: 17A/39, WEA, GANESH NAGAR17A/39, WEA, GANESH NAGAR, DELHI, DELHI, 110005<br />
                    Mobile: 9555158922<br />
                    Email: mantu@obsessions.co.in<br />
                    GST No.: 07AAACK4409J3ZI
                  </p>
                  </div>
                </div>

                <div className="col-md-4 col-sm-12">
                  <div className="p-2" style={ { border:" 1px solid rgb(222, 222, 222)", minHeight:"153px", marginBottom: "10px " }}>

                  <p className="text-sm mb-1"><strong>Delivery Information</strong></p>
                  <p className="text-sm P-text mb-1">
                    Usually Dispatched Within 2 to 3 Days
                    Delivery to: 17A/39, WEA, GANESH NAGAR17A/39, WEA, GANESH NAGAR, 166, DELHI, 110005
                  </p>
                  <DeliveryInformation />
                  </div>
                </div>

                <div className="col-md-4">
                   <div className="p-2" style={ { border:" 1px solid rgb(222, 222, 222)", minHeight:"153px", marginBottom: "10px ", maxHeight:"300px" }}>
                  <p className="text-sm mb-1"><strong>Order Details</strong></p>
                  <p className="text-sm P-text">
                    Order Date: 01-May, 2025 <br />
                    ASM/RSM: Dileep Chaudhary
                  </p>
                  <textarea name="" placeholder="Enter Remark" className="form-control control-input"></textarea>
                  </div>
                </div>
              </div>

              <div className="table-box-content">
                <div className="table-responsive">
                  <table className="table table-lg table-boxrto mb-0" style={{ width: "100%" }}>
                    <thead className="text-center">
                      <tr>
                        <th className="table-header" width="75"> Image </th>
                        <th className="table-header">Design & Shade</th>
                        <th className="table-header">Size</th>
                        <th className="table-header">Stock</th>
                        <th className="table-header">Order Qty.</th>
                        <th className="table-header">GST%</th>
                        <th className="table-header">MRP (<i className="bi bi-currency-rupee"></i>) </th>
                        <th className="table-header">Amount</th>
                        <th className="table-header" width="90"> &nbsp; </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="align-middle" width="75">
                          <img className="img-fluid" style={{ fontSize: "13px", padding: "3px", width: "50px", height: "auto" }} src="https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2b-img/EnvogueImages/Quality/Affinity_reversible/BRIGHT_WHITE_BRIGHT_WHITE.jpg" alt="product-1" />
                        </td>
                        <td className="align-middle" width="215"><Link to="/" style={{ fontSize: "12px" }}> BRIGHT WHITE BRIGHT WHITE </Link> </td>
                        <td className="align-middle text-center"> 40X60 </td>
                        <td className="align-middle text-center"> 155 </td>
                        <td className="align-middle text-center">
                          <select className="form-control form-control-sm select-List">
                            <option value="1"> 0 </option>
                            <option value="2"> 2 </option>
                            <option value="3"> 3 </option>
                            <option value="4"> 4 </option>
                            <option value="5"> 5 </option>
                            <option value="6"> 6 </option>
                            <option value="7"> 7 </option>
                          </select>
                        </td>
                        <td className="align-middle"> 12.00 </td>
                        <td className="align-middle text-center"> 550.00 </td>
                        <td className="align-middle text-center"> 550.00 </td>
                        <td className="align-middle text-center">
                          <div className="customer-selected-cart">
                            <button type="button" className="btn btn-sm btn-outline-secondary addtocart" title="Add to Cart">
                              <i className="fa fa-spinner fa-spin d-none" id="spinner_31185"></i>
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                        {/*---- Repeat rows as necessary-----*/}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="box-amount">
                <Button className="btn btnprimary mb-1" style={{ border: "none" }}> ORDER Summary </Button>
                <div className="d-flex">
                  <span> Order Qty. </span>
                  <div className="ml-auto"><span style={{ marginLeft: "-37px" }} className="update-qty">2</span></div>
                </div>
                <div className="d-flex">
                  <span> Taxable Value </span>
                  <div className="ml-auto"><span style={{ marginLeft: "-37px" }} className="update-qty"> <i className="bi bi-currency-rupee"></i>1249.54 </span></div>
                </div>
                <div className="d-flex">
                  <span> GST Amount </span>
                  <div className="ml-auto"><span style={{ marginLeft: "-37px" }} className="update-qty"> <i className="bi bi-currency-rupee"></i>195.00 </span></div>
                </div>
                <div className="d-flex">
                  <span> Total Amount </span>
                  <div className="ml-auto"><span style={{ marginLeft: "-37px" }} className="update-qty"> <i className="bi bi-currency-rupee"></i>1445 </span></div>
                </div>
                <div className="d-flex">
                  <span style={{ fontSize: "12px" }}> ( ONE THOUSAND TWO HUNDRED THIRTY TWO AND SEVEN PAISA ONLY ) </span>
                </div>
                <Button className="btn btnyellow mt-1" style={{ backgroundColor: "#f7d42e", border: "none" }}> ORDER NOW </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Summarys;
